import { UserBooking } from '../types/userBookings'
import { callApi } from '../utils/api'
import { getLocalStorageUserToken } from '../utils/localStorage'
import { endpoints } from './config'

type GetUserBookingsProps = {
  salonGuid: string
}

export const getUserBookings = async ({ salonGuid }: GetUserBookingsProps): Promise<UserBooking[] | null> => {
  const userToken = getLocalStorageUserToken()

  if (!userToken) return null

  const response = await callApi<UserBooking[]>({
    path: `${endpoints.getUserBookings}?${new URLSearchParams({ refSalonGuid: salonGuid }).toString()}`,
    token: userToken
  })

  if (!response.isOk || !response.data) {
    return null
  }

  return response.data
}

export const cancelAppointment = async (appointmentId: string) => {
  const response = await callApi({
    path: `${endpoints.cancelAppointment}?terminGuid=${appointmentId}`
  })

  if (!response.isOk || !response.data) {
    return null
  }

  return response.data
}
